import * as d3 from 'd3-selection'
import NSS from 'nss-animation'

export default {
  props: {
    model: Object,
    svgMargin: Number
  },
  data: function () {
    return {
      loaded: false,
      over: false,
      svg: null,
      anims: []
    }
  },
  mounted () {
    // console.log(this.model)
    this.svg = d3.select(this.$el)
    this.anims.push(NSS.InGlitchyDeform)
    this.anims.push(NSS.InOutWave)
  },
  methods: {
    onUpdateIn (animRatio) {
      this.svg.select('path').attr('d', this.model.pathDatas.svgPath())
      // this.svg.style('opacity', animRatio * 2)
    },
    anim: function () {
      if (this.model.pathDatas === undefined) {
        this.model.pathDatas = NSS.AnimatorHelper.createPathDatasFromSVGPath(this.model.path, 0, 0)
      }
      const options = {
        xOffset: 200,
        yOffset: 200,
        speed: 0.02
      }
      NSS.AnimatorHelper.getAnimator().addAnimation(new this.anims[parseInt(Math.random() * this.anims.length)](this.model.pathDatas, options, this.onUpdateIn, null))
    },
    mouseOver: function (e) {
      e.preventDefault()
      if (!this.over) {
        this.over = true
        this.anim()
      }
    },
    mouseOut: function (e) {
      e.preventDefault()
      if (this.over) {
        this.over = false
      }
    }
  }
}
